
export class multipleImageupload {
  uploadFileType: UploadFileType;
  files: File[];
  googleDrivePath: string;
  companyId?: number;
}

export enum UploadFileType {
  None,
  Documents,
  GoogleTPImage,
  ReportImage
}